module.exports = __webpack_public_path__ + "static/media/do-something.8ad66505.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/do-something.svg
// module id = 603
// module chunks = 0